import React from 'react';
import { FrameProps } from 'types/common/PropsTypes';

const FrameContainer = ({ addClassName, children }: FrameProps) => {
  return <div className={`container${addClassName ? `-${addClassName}` : ''}`}>{children}</div>;
};

export default React.memo(FrameContainer);
